
export const hubbleEntryEvent = () => {
  try {
    window.DATracker.track("entry-event", {
      pathName: location.pathname,
      query: location.search
    });
  } catch (error) {
    console.error(error)
  }
}

export const reportEvent = (event, data = {}) => {
  try {
    console.log(`%c${event}`, "color:green;font-family:system-ui;font-size:1rem;-webkit-text-stroke: 1px black;font-weight:bold")
    window.DATracker.track(event, {
      ...data
    })
  } catch (error) {
    console.error(error)
  }
}

export const addReportParam = (k, v) => {
  window.DATracker.push(['_addPost', k, v])
}

export const reportErrorEvent = (data, eventName = 'request_error') => {
  window.DATracker.track(eventName, {
    ...data
  })
}